<template>
  <v-container :class="MobileSize ? 'mt-3' : ''">
  <!-- <v-container grid-list-xs> -->
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">ใบเสนอราคา</v-card-title>
      <v-card-title style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else><v-icon color="#1AB759" class="mr-2" @click="backToMenu()">mdi-chevron-left</v-icon> ใบเสนอราคา</v-card-title>
      <!-- <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay> -->
      <v-row no-gutters>
        <v-col cols="12" class="px-2 py-0">
          <a-tabs @change="SelectDetailOrder">
            <a-tab-pane :key="0"><span slot="tab">ทั้งหมด <a-tag color="#27AB9C" style="border-radius: 8px;">{{ countPOAll }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="1"><span slot="tab">สร้างรายการสั่งซื้อแล้ว <a-tag color="#1AB759" style="border-radius: 8px;">{{ countPOSuccess }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="2"><span slot="tab">อนุมัติแล้ว <a-tag color="#1AB759" style="border-radius: 8px;">{{ countPOActive }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="3"><span slot="tab">รออนุมัติ <a-tag color="#FAAD14" style="border-radius: 8px;">{{ countPOWaitingApprove }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="4"><span slot="tab">ถูกแก้ไข <a-tag color="#FAAD14" style="border-radius: 8px;">{{ countPOEdited }}</a-tag></span></a-tab-pane>
            <a-tab-pane :key="5"><span slot="tab">ยกเลิก/ปฏิเสธ <a-tag color="#F5222D" style="border-radius: 8px;">{{ countPOReject }}</a-tag></span></a-tab-pane>
          </a-tabs>
        </v-col>
        <v-col v-if="disableTable === true" cols="12" md="6" sm="12" class="" :class="!MobileSize ? 'pl-3 pr-3 mb-3' : 'pl-2 pr-2 mb-3'">
          <v-text-field v-model="search" dense hide-details rounded outlined placeholder="ค้นหาจากชื่อร้านค้าหรือหมายเลขใบเสนอราคา ">
            <v-icon slot="append">mdi-magnify</v-icon>
          </v-text-field>
        </v-col>
        <v-col v-if="disableTable === true" cols="12" md="12" sm="12" class="" :class="!MobileSize ? 'pl-4 pr-3 mb-0 mt-1' : 'pl-2 pr-2 mb-3 mt-3'">
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-if="StateStatus === 0">รายการใบเสนอราคาทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 1">รายการใบเสนอราคาที่สร้างรายการสั่งซื้อแล้วทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 2">รายการใบเสนอราคาที่อนุมัติแล้วทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 3">รายการใบเสนอราคาที่รออนุมัติทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 4">รายการใบเสนอราคาที่ถูกแก้ไขทั้งหมด {{ showCountOrder }} รายการ</span>
          <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="StateStatus === 5">รายการใบเสนอราคาที่ยกเลิก/ปฏิเสธทั้งหมด {{ showCountOrder }} รายการ</span>
        </v-col>
        <v-col cols="12">
          <v-card v-if="disableTable === true" outlined class="small-card mx-4 my-5" min-height="436">
            <v-data-table
              :headers="keyCheckHead == 0 ? headers : keyCheckHead == 1 ? headersSuccess : keyCheckHead == 2 ? headersActive : keyCheckHead == 3 ? headersWaitingApprove : keyCheckHead == 4 ? headersEdited : headersFail"
              :items="DataTable"
              :search="search"
              :page.sync="page"
              style="width:100%;"
              height="100%"
              @pagination="countOrdar"
              :items-per-page="10"
              class=""
              no-results-text="ไม่พบชื่อบริษัทหรือหมายเลขใบเสนอราคาที่ค้นหา"
              :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            >
              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'success'">
                  <v-chip :class="!MobileSize ? 'ma-2' : 'mb-2'" color="#F0F9EE" text-color="#1AB759">สร้างรายการสั่งซื้อแล้ว</v-chip>
                </span>
                <span v-else-if="item.status === 'active'">
                  <v-chip :class="!MobileSize ? 'ma-2' : 'mb-2'" color="#F0F9EE" text-color="#1AB759">อนุมัติแล้ว</v-chip>
                </span>
                <span v-else-if="item.status === 'waiting_approve'">
                  <v-chip :class="!MobileSize ? 'ma-2' : 'mb-2'" color="#FCF0DA" text-color="#FAAD14">รออนุมัติ</v-chip>
                </span>
                <span v-else-if="item.status === 'edited'">
                  <v-chip :class="!MobileSize ? 'ma-2' : 'mb-2'" color="#FCF0DA" text-color="#FAAD14">ถูกแก้ไข</v-chip>
                </span>
                <span v-else-if="item.status === 'reject'">
                  <v-chip :class="!MobileSize ? 'ma-2' : 'mb-2'" color="#F7D9D9" text-color="#F5222D">ปฏิเสธ</v-chip>
                </span>
                <span v-else>
                  <v-chip :class="!MobileSize ? 'ma-2' : 'mb-2'" color="#F7D9D9" text-color="#F5222D">ยกเลิก</v-chip>
                </span>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                {{item.created_at}}
                <!-- {{new Date(item.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })}} -->
              </template>
              <template v-slot:[`item.payment_transaction_number`]="{ item }">
                {{ item.payment_transaction_number === null ? '-' : item.payment_transaction_number}}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn style="border: 1px solid #F2F2F2; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"  outlined small @click="goPDFQU(item)">
                  <v-icon color="#27AB9C" class="">mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn text rounded color="#27AB9C" small @click="goDetailQU(item)">
                  <b>รายละเอียด</b>
                  <v-icon small>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="disableTable === false" align="center">
          <div class="my-5">
            <v-img src="@/assets/emptypo.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
          </div>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-if="StateStatus === 0"><b>คุณยังไม่มีรายการใบเสนอราคา</b></h2>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-else-if="StateStatus === 1"><b>คุณยังไม่มีรายการใบเสนอราคาที่สร้างรายการสั่งซื้อแล้ว</b></h2>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-else-if="StateStatus === 2"><b>คุณยังไม่มีรายการใบเสนอราคาที่อนุมัติแล้ว</b></h2>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-else-if="StateStatus === 3"><b>คุณยังไม่มีรายการใบเสนอราคาที่รออนุมัติ</b></h2>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-else-if="StateStatus === 4"><b>คุณยังไม่มีรายการใบเสนอราคาที่ถูกแก้ไข</b></h2>
          <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;" v-else-if="StateStatus === 5"><b>คุณยังไม่มีรายการใบเสนอราคาที่ยกเลิก/ปฏิเสธ</b></h2>
        </v-col>
      </v-row>
    </v-card>
  <!-- </v-container> -->
  </v-container>
</template>

<script>
import { Encode, Decode } from '@/services'
export default {
  data () {
    return {
      orderList: [],
      StateStatus: 0,
      showCountOrder: 0,
      disableTable: false,
      companyData: [],
      dataRole: '',
      page: 1,
      keyCheckHead: 0,
      headers: [
        { text: 'หมายเลขใบเสนอราคา', value: 'qu_number', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '230' },
        { text: 'ร้านค้า', value: 'shop_name', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '270' },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false, filterable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'สถานะ', value: 'status', sortable: false, filterable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'หมายเลขอ้างอิง', value: 'payment_transaction_number', filterable: false, sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '200' }
      ],
      headersSuccess: [
        { text: 'หมายเลขใบเสนอราคา', value: 'qu_number', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '230' },
        { text: 'ร้านค้า', value: 'shop_name', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '270' },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false, filterable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'สถานะ', value: 'status', sortable: false, filterable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'หมายเลขอ้างอิง', value: 'payment_transaction_number', filterable: false, sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '200' }
      ],
      headersActive: [
        { text: 'หมายเลขใบเสนอราคา', value: 'qu_number', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '230' },
        { text: 'ร้านค้า', value: 'shop_name', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '270' },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false, filterable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'สถานะ', value: 'status', sortable: false, filterable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'หมายเลขอ้างอิง', value: 'payment_transaction_number', filterable: false, sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '200' }
      ],
      headersWaitingApprove: [
        { text: 'หมายเลขใบเสนอราคา', value: 'qu_number', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '230' },
        { text: 'ร้านค้า', value: 'shop_name', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '270' },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false, filterable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'สถานะ', value: 'status', sortable: false, filterable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'หมายเลขอ้างอิง', value: 'payment_transaction_number', filterable: false, sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '200' }
      ],
      headersEdited: [
        { text: 'หมายเลขใบเสนอราคา', value: 'qu_number', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '230' },
        { text: 'ร้านค้า', value: 'shop_name', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '270' },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false, filterable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'สถานะ', value: 'status', sortable: false, filterable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'หมายเลขอ้างอิง', value: 'payment_transaction_number', filterable: false, sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '200' }
      ],
      headersFail: [
        { text: 'หมายเลขใบเสนอราคา', value: 'qu_number', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '230' },
        { text: 'ร้านค้า', value: 'shop_name', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '270' },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false, filterable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'สถานะ', value: 'status', sortable: false, filterable: false, align: 'center', class: 'backgroundTable fontTable--text fontSizeDetail' },
        { text: 'หมายเลขอ้างอิง', value: 'payment_transaction_number', filterable: false, sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '180' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'start', class: 'backgroundTable fontTable--text fontSizeDetail', width: '200' }
      ],
      receive_items: [
        { text: 'ยังไม่รับ', value: 'not_received' },
        { text: 'รับของแล้ว', value: 'received' }
      ],
      statusSend: { text: 'ยังไม่รับ', value: 'not_received' },
      DataTable: [],
      customClick: (record) => ({
        on: {
          click: () => {
            this.pendingData(record)
          }
        }
      }),
      overlay: false,
      ProcurementData: '',
      responseData: '',
      checkbox: true,
      search: '',
      countPOAll: 0,
      countOrderPending: 0,
      countPOSuccess: 0,
      countPOActive: 0,
      countPOWaitingApprove: 0,
      countPOEdited: 0,
      countOrderApprove: 0
    }
  },
  computed: {
    DataListOrder () {
      return this.responseData
    },
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: '/QUCompanyMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/QUCompany' }).catch(() => {})
      }
    },
    DataTable (val) {
      // console.log('DataTable', val)
    },
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 500)
    },
    StateStatus (val) {
      // console.log('val', val)
      if (val === 0) {
        // this.DataTable = this.orderList.data.all
        this.DataTable = this.orderList.data.all.map(x => {
          return {
            qu_number: x.qu_number,
            shop_name: x.shop_name,
            created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
            status: x.status,
            payment_transaction_number: x.payment_transaction_number,
            pdf_path_qu: x.pdf_path_qu,
            pdf_for_buyer: x.pdf_for_buyer,
            order_id: x.order_id,
            id: x.id,
            company_id: x.company_id,
            seller_shop_id: x.seller_shop_id,
            buyer_name: x.buyer_name,
            payment_method: x.payment_method,
            com_perm_id: x.com_perm_id
          }
        })
        this.keyCheckHead = 0
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 1) {
        // this.DataTable = this.orderList.data.success
        this.DataTable = this.orderList.data.success.map(x => {
          return {
            qu_number: x.qu_number,
            shop_name: x.shop_name,
            created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
            status: x.status,
            payment_transaction_number: x.payment_transaction_number,
            pdf_path_qu: x.pdf_path_qu,
            pdf_for_buyer: x.pdf_for_buyer,
            order_id: x.order_id,
            id: x.id,
            company_id: x.company_id,
            seller_shop_id: x.seller_shop_id,
            buyer_name: x.buyer_name,
            payment_method: x.payment_method,
            com_perm_id: x.com_perm_id
          }
        })
        this.keyCheckHead = 1
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 2) {
        // this.DataTable = this.orderList.data.active
        this.DataTable = this.orderList.data.active.map(x => {
          return {
            qu_number: x.qu_number,
            shop_name: x.shop_name,
            created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
            status: x.status,
            payment_transaction_number: x.payment_transaction_number,
            pdf_path_qu: x.pdf_path_qu,
            pdf_for_buyer: x.pdf_for_buyer,
            order_id: x.order_id,
            id: x.id,
            company_id: x.company_id,
            seller_shop_id: x.seller_shop_id,
            buyer_name: x.buyer_name,
            payment_method: x.payment_method,
            com_perm_id: x.com_perm_id
          }
        })
        this.keyCheckHead = 2
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 3) {
        // this.DataTable = this.orderList.data.waiting_approve
        this.DataTable = this.orderList.data.waiting_approve.map(x => {
          return {
            qu_number: x.qu_number,
            shop_name: x.shop_name,
            created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
            status: x.status,
            payment_transaction_number: x.payment_transaction_number,
            pdf_path_qu: x.pdf_path_qu,
            pdf_for_buyer: x.pdf_for_buyer,
            order_id: x.order_id,
            id: x.id,
            company_id: x.company_id,
            seller_shop_id: x.seller_shop_id,
            buyer_name: x.buyer_name,
            payment_method: x.payment_method,
            com_perm_id: x.com_perm_id
          }
        })
        this.keyCheckHead = 3
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 4) {
        // this.DataTable = this.orderList.data.edited
        this.DataTable = this.orderList.data.edited.map(x => {
          return {
            qu_number: x.qu_number,
            shop_name: x.shop_name,
            created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
            status: x.status,
            payment_transaction_number: x.payment_transaction_number,
            pdf_path_qu: x.pdf_path_qu,
            pdf_for_buyer: x.pdf_for_buyer,
            order_id: x.order_id,
            id: x.id,
            company_id: x.company_id,
            seller_shop_id: x.seller_shop_id,
            buyer_name: x.buyer_name,
            payment_method: x.payment_method,
            com_perm_id: x.com_perm_id
          }
        })
        this.keyCheckHead = 4
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else if (val === 5) {
        // this.DataTable = this.orderList.data.reject
        this.DataTable = this.orderList.data.reject.map(x => {
          return {
            qu_number: x.qu_number,
            shop_name: x.shop_name,
            created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
            status: x.status,
            payment_transaction_number: x.payment_transaction_number,
            pdf_path_qu: x.pdf_path_qu,
            pdf_for_buyer: x.pdf_for_buyer,
            order_id: x.order_id,
            id: x.id,
            company_id: x.company_id,
            seller_shop_id: x.seller_shop_id,
            buyer_name: x.buyer_name,
            payment_method: x.payment_method,
            com_perm_id: x.com_perm_id
          }
        })
        this.keyCheckHead = 5
        if (this.DataTable.length === 0) {
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      }
    }
  },
  async created () {
    // console.log('StateStatus', this.StateStatus)
    this.$EventBus.$emit('changeNavCompany')
    this.$EventBus.$emit('checkPathCompany')
    this.$EventBus.$on('ListDataTable', this.ListDataTable)
    this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
    if (localStorage.getItem('oneData') !== null && localStorage.getItem('CompanyData') !== null) {
      this.companyData = JSON.parse(Decode.decode(localStorage.getItem('CompanyData')))
      this.ListDataTable()
    } else {
      this.$router.push({ path: '/' }).catch(() => {})
    }
  },
  methods: {
    backToMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/companyMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/detailCompany' }).catch(() => {})
      }
    },
    async ListDataTable () {
      this.countPOAll = 0
      this.countPOReject = 0
      this.countPOSuccess = 0
      this.countPOActive = 0
      this.countPOWaitingApprove = 0
      this.countPOEdited = 0
      var data = {
        company_id: this.companyData.id
      }
      // console.log('data before send =========>', data)
      await this.$store.dispatch('actionsListPOBuyer', data)
      this.orderList = await this.$store.state.ModuleAdminManage.stateListPOBuyer
      // console.log('Data =====>', this.orderList)
      if (this.orderList.result === 'SUCCESS') {
        if (this.orderList.message === 'List QU Setting success.') {
          this.countPOAll = this.orderList.data.all.length
          this.countPOReject = this.orderList.data.reject.length
          this.countPOSuccess = this.orderList.data.success.length
          this.countPOActive = this.orderList.data.active.length
          this.countPOWaitingApprove = this.orderList.data.waiting_approve.length
          this.countPOEdited = this.orderList.data.edited.length
          // console.log(this.countPOAll, this.countOrderPending, this.countPOSuccess, this.countPOWaitingApprove, this.countPOActive, this.countPOEdited)
          if (this.StateStatus === 0) {
            // this.DataTable = this.orderList.data.all
            this.DataTable = this.orderList.data.all.map(x => {
              return {
                qu_number: x.qu_number,
                shop_name: x.shop_name,
                created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
                status: x.status,
                payment_transaction_number: x.payment_transaction_number,
                pdf_path_qu: x.pdf_path_qu,
                pdf_for_buyer: x.pdf_for_buyer,
                order_id: x.order_id,
                id: x.id,
                company_id: x.company_id,
                seller_shop_id: x.seller_shop_id,
                buyer_name: x.buyer_name,
                payment_method: x.payment_method,
                com_perm_id: x.com_perm_id
              }
            })
            if (this.DataTable.length === 0) {
              this.disableTable = false
            } else {
              this.disableTable = true
            }
          } else if (this.StateStatus === 1) {
            // this.DataTable = this.orderList.data.success
            this.DataTable = this.orderList.data.success.map(x => {
              return {
                qu_number: x.qu_number,
                shop_name: x.shop_name,
                created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
                status: x.status,
                payment_transaction_number: x.payment_transaction_number,
                pdf_path_qu: x.pdf_path_qu,
                pdf_for_buyer: x.pdf_for_buyer,
                order_id: x.order_id,
                id: x.id,
                company_id: x.company_id,
                seller_shop_id: x.seller_shop_id,
                buyer_name: x.buyer_name,
                payment_method: x.payment_method,
                com_perm_id: x.com_perm_id
              }
            })
            if (this.DataTable.length === 0) {
              this.disableTable = false
            } else {
              this.disableTable = true
            }
          } else if (this.StateStatus === 2) {
            // this.DataTable = this.orderList.data.active
            this.DataTable = this.orderList.data.active.map(x => {
              return {
                qu_number: x.qu_number,
                shop_name: x.shop_name,
                created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
                status: x.status,
                payment_transaction_number: x.payment_transaction_number,
                pdf_path_qu: x.pdf_path_qu,
                pdf_for_buyer: x.pdf_for_buyer,
                order_id: x.order_id,
                id: x.id,
                company_id: x.company_id,
                seller_shop_id: x.seller_shop_id,
                buyer_name: x.buyer_name,
                payment_method: x.payment_method,
                com_perm_id: x.com_perm_id
              }
            })
            if (this.DataTable.length === 0) {
              this.disableTable = false
            } else {
              this.disableTable = true
            }
          } else if (this.StateStatus === 3) {
            // this.DataTable = this.orderList.data.waiting_approve
            this.DataTable = this.orderList.data.waiting_approve.map(x => {
              return {
                qu_number: x.qu_number,
                shop_name: x.shop_name,
                created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
                status: x.status,
                payment_transaction_number: x.payment_transaction_number,
                pdf_path_qu: x.pdf_path_qu,
                pdf_for_buyer: x.pdf_for_buyer,
                order_id: x.order_id,
                id: x.id,
                company_id: x.company_id,
                seller_shop_id: x.seller_shop_id,
                buyer_name: x.buyer_name,
                payment_method: x.payment_method,
                com_perm_id: x.com_perm_id
              }
            })
            if (this.DataTable.length === 0) {
              this.disableTable = false
            } else {
              this.disableTable = true
            }
          } else if (this.StateStatus === 4) {
            // this.DataTable = this.orderList.data.edited
            this.DataTable = this.orderList.data.edited.map(x => {
              return {
                qu_number: x.qu_number,
                shop_name: x.shop_name,
                created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
                status: x.status,
                payment_transaction_number: x.payment_transaction_number,
                pdf_path_qu: x.pdf_path_qu,
                pdf_for_buyer: x.pdf_for_buyer,
                order_id: x.order_id,
                id: x.id,
                company_id: x.company_id,
                seller_shop_id: x.seller_shop_id,
                buyer_name: x.buyer_name,
                payment_method: x.payment_method,
                com_perm_id: x.com_perm_id
              }
            })
            if (this.DataTable.length === 0) {
              this.disableTable = false
            } else {
              this.disableTable = true
            }
          } else if (this.StateStatus === 5) {
            // this.DataTable = this.orderList.data.reject
            this.DataTable = this.orderList.data.reject.map(x => {
              return {
                qu_number: x.qu_number,
                shop_name: x.shop_name,
                created_at: new Date(x.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }),
                status: x.status,
                payment_transaction_number: x.payment_transaction_number,
                pdf_path_qu: x.pdf_path_qu,
                pdf_for_buyer: x.pdf_for_buyer,
                order_id: x.order_id,
                id: x.id,
                company_id: x.company_id,
                seller_shop_id: x.seller_shop_id,
                buyer_name: x.buyer_name,
                payment_method: x.payment_method,
                com_perm_id: x.com_perm_id
              }
            })
            if (this.DataTable.length === 0) {
              this.disableTable = false
            } else {
              this.disableTable = true
            }
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            text: 'ผู้ใช้งานนี้ไม่มีสิทธิ์การเข้าถึงใบเสนอราคาบริษัท',
            showConfirmButton: false,
            timer: 1500
          })
          this.$router.push({ path: '/detailCompany' }).catch(() => {})
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          text: 'ผู้ใช้งานนี้ถูกใช้งานอยู่',
          showConfirmButton: false,
          timer: 1500
        })
        localStorage.removeItem('oneData')
      }
      // console.log('DataTable===>', this.DataTable)
    },
    countOrdar (pagination) {
      this.showCountOrder = pagination.itemsLength
    },
    async UpdateStatusBuyer (item) {
      // console.log(item)
      if (item.seller_sent_status === 'not_sent') {
        this.$swal.fire({
          icon: 'warning',
          text: 'สินค้ากำลังจัดส่ง',
          showConfirmButton: false,
          timer: 1500
        })
        await this.ListDataTable()
      } else {
        const update = {
          order_number: item.order_number,
          buyer_received_status: item.buyer_received_status
        }
        // console.log('update', update)
        await this.$store.dispatch('actionUpdateStatusBuyer', update)
        this.$swal.fire({
          icon: 'success',
          text: 'บันทึกข้อมูลสำเร็จ',
          showConfirmButton: false,
          timer: 1500
        })
        await this.ListDataTable()
      }
    },
    async GoToPayment (item) {
      const PaymentID = {
        payment_transaction_number: item.payment_transaction_number
      }
      // console.log('payment_transaction_number', PaymentID)
      await this.$store.dispatch('ActionGetPaymentPage', PaymentID)
      var response = this.$store.state.ModuleCart.stateGetPaymentPage
      // console.log('respose paymenttttttttt', response)
      await localStorage.setItem('PaymentData', Encode.encode(response))
      this.$router.push('/RedirectPaymentPage')
    },
    async orderDetail (val) {
      // console.log('path to not tell =====>', val.pdf_for_buyer)
      window.open(`${val.pdf_for_buyer}`)
      // var data = {
      //   payment_transaction_number: val.payment_transaction_number
      // }
      //   console.log('data naja', data)
      // await this.$store.dispatch('actionOrderDetail', data)
      // await this.$router.push({ path: '/quotation1shop' }).catch(() => {})
      // var response = await this.$store.state.ModuleOrder.stateOrderDetailData
      // console.log('order detail na', response)
      // if (response.result === 'SUCCESS') {
      //   this.OrderDetailProp = response.data
      //   console.log('กี่ร้านนะะะะะะะะะ', response.data[0].order_number[0])
      // }
    },
    SelectDetailOrder (item) {
      // console.log('SelectDetailOrder', item)
      this.StateStatus = item
      this.page = 1
    },
    SwitchRole () {
      this.dataRole = JSON.parse(localStorage.getItem('roleUser'))
      this.ListDataTable()
    },
    // async getDataTable () {
    //   this.overlay = true
    //   const data = {
    //     procurement_org_id: this.ProcurementData.procurement_org_id
    //   }
    //   await this.$store.dispatch('actionListOrderProcurement', data)
    //   var response = await this.$store.state.ModuleCart.stateListOrderProcurement
    //   console.log('response List Order Procurement', response)
    //   if (response.result === 'SUCCESS') {
    //     this.responseData = response.data
    //     this.overlay = false
    //   }
    // },
    async pendingData (item) {
      this.overlay = true
      const data = {
        order_id: item.order_id
      }
      await this.$store.dispatch('actionOrderDetail', data)
      var response = await this.$store.state.ModuleCart.stateOrderDetailData
      // console.log('response detail order', response)
      if (response.result === 'SUCCESS') {
        this.overlay = false
        localStorage.setItem('MyOrderDetail', Encode.encode(JSON.stringify(response.data)))
        this.$router.push('/myorderdetail')
      }
    },
    goPDFQU (item) {
      window.open(`${item.pdf_path_qu}`)
    },
    goDetailQU (item) {
      // console.log(item)
      var QUID = item.id
      var id = item.company_id
      var shopID = item.seller_shop_id
      localStorage.setItem('detailItemQU', Encode.encode(item))
      if (this.MobileSize === false) {
        this.$router.push({ path: `/QUCompanyDetail?QU_ID=${QUID}&id=${id}&shopID=${shopID}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/QUCompanyDetailMobile?QU_ID=${QUID}&id=${id}&shopID=${shopID}` }).catch(() => {})
      }
    }
  }
}
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  font-size: 14px !important;
}
</style>

<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(6) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(1) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(6) {
          z-index: 11;
          background: white;
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
        }
      }
    }
  }
</style>

<style scoped>
.fontSizeDetail {
  font-weight: 700 !important; font-size: 14px !important; line-height: 22px !important; color: #333333 !important;
}
.v-data-table /deep/ .v-data-footer {
  font-size: 0.62rem;
}
</style>
